import { useEffect, useState } from 'react'

import { jingleCollectionByIdQuery } from '@/entities/jingle-collections'
import { StretchedTabs } from '@/shared/ui'
import { RoundedTabLabel } from '@/shared/ui'
import {
  CheckOutlined,
  PushpinOutlined,
  UnorderedListOutlined,
} from '@ant-design/icons'
import { useUnit } from 'effector-react'
import { useLocation, useNavigate } from 'react-router-dom'

import { JingleCollectionFormCommonInformation } from './ui/JingleCollectionFormCommonInformation'
import { JingleCollectionFormJingles } from './ui/JingleCollectionFormJingles'

export {
  lastCreatedJingleCollectionIdReset,
  $lastCreatedJingleCollectionId,
} from './model/jingle-collection-form-common-information.model'

export enum JingleCollectionFormTabsKeys {
  CommonInformation = 'common_information',
  Jingles = 'jingles',
}

interface JingleCollectionFormProps {
  onJingleEditButtonClick?: (id: string) => void
}

export const JingleCollectionForm = ({
  onJingleEditButtonClick,
}: JingleCollectionFormProps) => {
  const location = useLocation()
  const navigate = useNavigate()
  const state = location.state as { activeTab?: JingleCollectionFormTabsKeys }

  const [activeTabKey, setActiveTabKey] = useState(
    state?.activeTab ?? JingleCollectionFormTabsKeys.CommonInformation,
  )

  useEffect(() => {
    if (state?.activeTab) {
      void navigate(location.pathname, { replace: true, state: {} })
    }
  }, [navigate, location, state?.activeTab])
  //
  const jingleCollectionByIdQueryStatus = useUnit(
    jingleCollectionByIdQuery.$status,
  )
  const creating = jingleCollectionByIdQueryStatus === 'initial'

  return (
    <StretchedTabs
      activeKey={activeTabKey}
      onChange={(key: string) =>
        setActiveTabKey(key as JingleCollectionFormTabsKeys)
      }
      items={[
        {
          key: JingleCollectionFormTabsKeys.CommonInformation,
          label: (
            <RoundedTabLabel
              done={!creating}
              roundChildren={<UnorderedListOutlined />}
            >
              Общая информация
            </RoundedTabLabel>
          ),
          children: <JingleCollectionFormCommonInformation />,
        },
        {
          key: JingleCollectionFormTabsKeys.Jingles,
          disabled: creating,
          label: (
            <RoundedTabLabel
              roundChildren={<PushpinOutlined />}
              disabled={creating}
            >
              Джинглы
            </RoundedTabLabel>
          ),
          children: (
            <>
              {onJingleEditButtonClick && (
                <JingleCollectionFormJingles
                  onJingleEditButtonClick={onJingleEditButtonClick}
                />
              )}
            </>
          ),
        },
      ]}
    />
  )
}
